export const keys = {
  me: ["me"] as const,
  sessions: ["sessions"] as const,
  session: (id: string) => ["session", id] as const,
  messages: (sessionId: string) => ["session", sessionId, "messages"] as const,
  documents: (sessionId: string) =>
    ["session", sessionId, "documents"] as const,
  projects: (q: string) => ["gitlab", "projects", q] as const,
  branches: (projectId: number | null, q: string) =>
    ["gitlab", "branches", projectId, q] as const,
  openaiAccounts: ["openai", "accounts"] as const,
  anthropicAccounts: ["anthropic", "accounts"] as const,
  githubAccounts: ["github", "accounts"] as const,
  attachments: (sessionId: string) =>
    ["session", sessionId, "attachments"] as const,
  sessionOutputs: (sessionId: string) =>
    ["session", sessionId, "outputs"] as const,
  userSearch: (q: string) => ["users", "search", q] as const,
  collaboratorCandidates: (sessionId: string, q: string) =>
    ["session", sessionId, "collaborator-candidates", q] as const,
  maintenance: ["admin", "maintenance"] as const,
  version: ["version"] as const,
  changelog: ["changelog"] as const,
  /** Every cached What's new answer (one per tab build and language). */
  whatsNewAll: ["release-notes", "whats-new"] as const,
  whatsNew: (through: string, lang: string) => ["release-notes", "whats-new", through, lang] as const,
  releaseNotes: (lang: string) => ["release-notes", "list", lang] as const,
  agentProviders: ["agent", "providers"] as const,
  agentProviderModels: (slug: string) =>
    ["agent", "providers", slug, "models"] as const,
};

export const orgSetupFactsKey = (slug: string) =>
  ["orgs", slug, "setup-state"] as const;

export function isOrgSetupFactsKey(q: { queryKey: readonly unknown[] }): boolean {
  return q.queryKey[0] === "orgs" && q.queryKey[2] === "setup-state";
}
